import React, { useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Row, Col, Typography, UploadProps, Upload } from 'antd';
import { defaultApiOptions } from '../../api';
import store from '../../store';

const MAX_UNBLOCK_FILE_SIZE_IN_BYTES = 1024 * 1024; // 1MB

const { Text } = Typography;

type AdblockFileUploaderProps = { name?: string }

const AdblockFileUploader: React.FC<AdblockFileUploaderProps> = props => {
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const getFileExtension = (fileName: string) => {
        const lastDotIndex = fileName.lastIndexOf('.');
        if (lastDotIndex !== -1 && lastDotIndex < fileName.length - 1) {
            return fileName.substring(lastDotIndex + 1);
        }
        return '';
    };

    const uploadProps: UploadProps = {
        name: 'file',
        accept: '.xls,.xlsx',
        maxCount: 1,
        multiple: false,
        showUploadList: false,
        action: `${defaultApiOptions.baseURL}/adblock/byxls`,
        method: 'POST',
        headers: {
            accept: 'application/json, text/plain, */*',
            authorization: `Bearer ${store.getState().user.jwtToken}`,
        },
        beforeUpload: (file) => {
            setShowErrorMessage(false);

            if (file.size > MAX_UNBLOCK_FILE_SIZE_IN_BYTES) {
                setShowErrorMessage(true);
                setErrorMessage(`This file (${file.name}) is too big.`);
                return false;
            }

            const fileExt = getFileExtension(file.name);

            if (fileExt !== 'xls' && fileExt !== 'xlsx') {
                setShowErrorMessage(true);
                setErrorMessage(`Wrong type of file (${fileExt})`);
                return false;
            }

            return true;
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    return (
        <Row
            gutter={10}
            justify="start"
            align="middle"
            wrap={false}
            style={{ width: '70%', marginLeft: 0, marginTop: 16 }}
        >
            <Col>
                <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined />}>Unblock by XLS</Button>
                </Upload>
            </Col>
            <Col>
                {showErrorMessage && <Text style={{ color: 'red' }}>{errorMessage}</Text>}
            </Col>
        </Row>
    );
};

export default AdblockFileUploader;
